import { render } from "./MAvoidFraud.vue?vue&type=template&id=741719b2&scoped=true"
import script from "./MAvoidFraud.vue?vue&type=script&lang=js"
export * from "./MAvoidFraud.vue?vue&type=script&lang=js"

import "./MAvoidFraud.vue?vue&type=style&index=0&id=741719b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741719b2"]])

export default __exports__